import React, { Component } from "react";
import { createDesktopApp, WEB2DESK_PAYMENT_REDIRECT_URL } from "../../../api";
import Dropzone from "react-dropzone";
import SimpleReactValidator from "simple-react-validator";
import Payment from "../../../payment";
import Track from "../../../track";

const getOsName = () => {
  let osName = "Unknown OS";
  if (navigator.appVersion.indexOf("Win") !== -1) osName = "windows";
  if (navigator.appVersion.indexOf("Mac") !== -1) osName = "osx";
  if (navigator.appVersion.indexOf("X11") !== -1) osName = "unix";
  if (navigator.appVersion.indexOf("Linux") !== -1) osName = "linux";
  return osName;
};
const osName = getOsName();

export default class Web2DeskCreate extends Component {
  validator = new SimpleReactValidator();
  state = {
    url: "",
    appname: "",
    appIcon: "",
    email: "",
    imageUrl: "",
    loading: false,
    errMessage: "",
    errType: "",
    showUpladingProgress: false,
    showCustomIconUpload: false,
    windowsEnabled: osName === "windows",
    linuxEnabled: osName === "linux",
    osxEnabled: osName === "osx",
    whiteLabelEnabled: false,
    errMessages: []
  };
  payment = new Payment({ onSuccess: console.log });
  handleCheckBox = key => e => {
    switch (key) {
      case "whiteLabelEnabled":
        Track.event({
          category: "Premium",
          action: "whiteLabelEnabled",
          label: e.target.checked.toString()
        });
        break;
      case "windowsEnabled":
        Track.event({
          category: "Web2Desk",
          action: "windowsEnabled",
          label: e.target.checked.toString()
        });
        break;
      case "linuxEnabled":
        Track.event({
          category: "Web2Desk",
          action: "linuxEnabled",
          label: e.target.checked.toString()
        });
        break;
      case "osxEnabled":
        Track.event({
          category: "Web2Desk",
          action: "osxEnabled",
          label: e.target.checked.toString()
        });
        break;

      default:
        break;
    }
    this.setState({ [key]: e.target.checked });
  };
  handleChange = field => e => {
    this.setState({ [field]: e.target.value });
    if (
      e.target.name === "url" &&
      e.target.value.match(
        /* eslint-disable */
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
      )
    ) {
      const url = e.target.value
        .replace("http://", "")
        .replace("https://", "")
        .split(/[/?#]/)[0];
      this.setState({
        imageUrl: `https://logo.clearbit.com/${url}`
      });
    }
  };
  handleSubmit = event => {
    event.preventDefault();
    if (this.state.whiteLabelEnabled) {
      Track.event({
        category: "Premium",
        action: "Click",
        label: "Make Payment"
      });
    }
    if (!this.validateForm()) {
      return;
    }

    const formData = new FormData(document.querySelector("form"));
    let label;
    if (!this.state.showCustomIconUpload) {
      formData.append("icon", this.state.imageUrl);
      label = "default-icon";
    } else {
      label = "custom-icon";
    }
    formData.append("windowsEnabled", this.state.windowsEnabled);
    formData.append("linuxEnabled", this.state.linuxEnabled);
    formData.append("osxEnabled", this.state.osxEnabled);
    formData.append("whiteLabelEnabled", this.state.whiteLabelEnabled);
    Track.event({
      category: "Web2Desk",
      action: "Create",
      label
    });
    this.setState({
      loading:true
    })
    createDesktopApp(formData)
      .then(response => {
        if (response.status) {
          this.setState({
            loading: false,
            error: false,
            appId: response.id
          });
          if (response.paymentRequired) {
            this.payment
              .setProduct({
                name: "WEB2DESK PREMIUM",
                price: window.appmakerProducts.web2DeskWhiteLabelPrice
              })
              .checkout({
                extranalRef: response.id,
                redirectUrl: WEB2DESK_PAYMENT_REDIRECT_URL,
                email: this.state.email
              });
          } else this.props.history.push("/web2desk/download/" + response.id);
        } else {
          this.setState({
            loading: false,
            error: true,
            error_message: response.message
          });
        }
        console.log(response);
      })
      .catch(ex => {
        this.setState({ loading: false });
      });
  };
  validateForm = () => {
    this.validator.message("appname", this.state.appname, "required");
    this.validator.message("url", this.state.url, "required|url");
    this.validator.message("email", this.state.email, "required|email");
    this.validator.allValid();
    const errMessages = Object.values(this.validator.getErrorMessages());
    if (
      !this.state.windowsEnabled &&
      !this.state.linuxEnabled &&
      !this.state.osxEnabled
    )
      errMessages.push("Please select at least one platform");
    this.setState({ errMessages });
    return (
      this.validator.allValid() &&
      (this.state.windowsEnabled ||
        this.state.linuxEnabled ||
        this.state.osxEnabled)
    );
  };
  onImageLoadError = e => {
    if (this.state.url !== "")
      this.setState({
        showCustomIconUpload: true
      });
  };
  onDrop(files) {
    const file = files[0];
    if (file) {
      this.setState({
        imageUrl: URL.createObjectURL(file)
      });
    }
  }
  render() {
    return (
      <section className="generator-step-1 web2desk-generator container-fluid">
        <h1 className="cover-heading mb-5 mt-4 text-center">
          Your Favorite{" "}
          <span role="img" aria-label="web">
            🌎
          </span>{" "}
          websites to{" "}
          <span role="img" aria-label="computer">
            🖥{" "}
          </span>{" "}
          desktop apps in{" "}
          <span role="img" aria-label="1">
            1️⃣{" "}
          </span>{" "}
          one click{" "}
          <span role="img" aria-label="rocket">
            🚀
          </span>
        </h1>
        <div className="row padding m-auto">
          <div className="step-1 col-lg-7 col-sm-12 m-auto active">
            <form onSubmit={this.handleSubmit}>
              <div className="row padding m-auto">
                <div className="step-1 col-sm-12 m-auto">
                  <label htmlFor="url">Website URL</label>
                  <div className="form-group mb-4">
                    <input
                      name="url"
                      id="url"
                      type="url"
                      className="form-control"
                      onChange={this.handleChange("url")}
                      value={this.state.url}
                      placeholder="Enter your url"
                      required
                    />
                  </div>
                  <label htmlFor="appname">App Name</label>
                  <div className="form-group mb-4">
                    <input
                      name="appname"
                      id="appname"
                      type="text"
                      className="form-control"
                      onChange={this.handleChange("appname")}
                      value={this.state.appname}
                      placeholder="Enter your App Name"
                      required
                    />
                  </div>
                  <label htmlFor="icon">App Icon</label>
                  <div className="appicon d-flex">
                    <div className="flex-grow-1">
                      <img
                        src={this.state.imageUrl}
                        alt=""
                        onError={this.onImageLoadError}
                      />
                    </div>
                    <div
                      id="custom-icon-toggle"
                      className="like-href"
                      onClick={e => {
                        this.setState({
                          showCustomIconUpload: !this.state.showCustomIconUpload
                        });
                      }}
                    >
                      <i className="fas fa-pencil-alt" />
                    </div>
                  </div>
                  {this.state.showUpladingProgress ? (
                    <div className="text-center m-4">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.showCustomIconUpload && (
                    <Dropzone onDrop={this.onDrop.bind(this)} accept="image/*">
                      {({ getRootProps, getInputProps, isDragActive }) => {
                        return (
                          <div
                            {...getRootProps()}
                            className={"dropzone box text-center"}
                          >
                            <input {...getInputProps()} name="icon" />
                            {isDragActive ? (
                              <p>Drop files here...</p>
                            ) : (
                              <div className="box_input">
                                <i className="fas fa-cloud-upload-alt uplaod_icon d-block" />
                                <label htmlFor="file">
                                  <strong>Choose a file</strong>
                                  <span className="box_dragndrop">
                                    {" "}
                                    or drag it here
                                  </span>
                                </label>
                                <br />
                              </div>
                            )}
                          </div>
                        );
                      }}
                    </Dropzone>
                  )}

                  <div className="app-verify text-center">
                    <h6 className="text-left">We’ll email you the Files</h6>
                    <div className="input-group">
                      <input
                        required
                        name="email"
                        type="email"
                        className="form-control"
                        id="email"
                        onChange={this.handleChange("email")}
                        placeholder="Email Id"
                      />
                    </div>
                  </div>

                  <label htmlFor="selectPlatform">Select Platform(s)</label>
                  <div className="selectPlatform">
                    <ul>
                      <li>
                        <input
                          type="checkbox"
                          id="windows"
                          checked={this.state.windowsEnabled}
                          onChange={this.handleCheckBox("windowsEnabled")}
                        />
                        <label for="windows">
                          <h5 className="mb-0">
                            <i className="fab fa-windows mr-4" />
                            Windows
                          </h5>{" "}
                        </label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          id="osx"
                          checked={this.state.osxEnabled}
                          onChange={this.handleCheckBox("osxEnabled")}
                        />
                        <label for="osx">
                          <h5 className="mb-0">
                            <i className="fab fa-apple mr-4" />
                            OSX
                          </h5>{" "}
                        </label>
                      </li>
                      <li>
                        <input
                          type="checkbox"
                          id="linux"
                          checked={this.state.linuxEnabled}
                          onChange={this.handleCheckBox("linuxEnabled")}
                        />
                        <label for="linux">
                          <h5 className="mb-0">
                            <i className="fab fa-linux mr-4" />
                            Linux
                          </h5>{" "}
                        </label>
                      </li>
                    </ul>
                  </div>

                  <div className="mt-3 mb-3 pro-switch">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={this.state.whiteLabelEnabled}
                        onChange={this.handleCheckBox("whiteLabelEnabled")}
                      />
                      <span className="slider round" />
                    </label>
                    <p className="d-inline-block ml-3 mb-0 font-weight-bold">
                      Remove Appmaker branding{" "}
                      <span className="font-italic">(Splash screen)</span>
                      <span class=" ml-2 badge badge-success">+${window.appmakerProducts.web2DeskWhiteLabelPrice}</span>
                    </p>
                    <br />
                  </div>

                  {this.state.errMessages &&
                    this.state.errMessages.length > 0 &&
                    this.state.errMessages.filter(Boolean).map(message => (
                      <div
                        className="alert alert-danger errorMessage"
                        role="alert"
                      >
                        {message}
                      </div>
                    ))}
                  <button
                    className="btn btn-success w-100"
                    onClick={this.handleSubmit}
                  >
                    {this.state.loading ? (
                      <span
                        className="spinner-grow spinner-grow-sm mr-4"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      ""
                    )}
                    {this.state.loading
                      ? "Building App"
                      : this.state.whiteLabelEnabled
                      ? "Make Payment"
                      : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    );
  }
}
